import React, { CSSProperties, useMemo } from 'react';
import AntdSpin from 'antd/lib/spin';
import { LoadingIcon } from './LoadingIcon';

/**
 * {@docCategory ActivityIndicator}
 */
export interface ActivityIndicatorProps {
   /**
    *	The size of ActivityIndicator, options: small, default and large
    */
   size?: 'large' | 'small' | 'default'

   /**
    * Whether ActivityIndicator is spinning
    */
   spinning?: boolean;

   /**
    * Specifies a delay in milliseconds for loading state (prevent flush)
    */
   delay?: number;

   /**
    * Customize description content when ActivityIndicator has children
    */
   text?: string;

   /**
    * The className of wrapper when Spin has children
    */
   wrapperClassName?: string;

   /**
    * React node of the spinning indicator
    */
   loadingIndicator?: boolean | React.ReactElement<HTMLElement>;

   /**
    * Sets a className on the indicator.
    */
   className?: string;

   /**
    * Sets styles on the indicator.
    */
   style?: CSSProperties;
}

export const ActivityIndicator = (props: React.PropsWithChildren<ActivityIndicatorProps>) => {
   const { loadingIndicator: loadingIndicatorProp, size, spinning } = props;

   const loadingIndicator: React.ReactElement<HTMLElement> | undefined = useMemo(()=>{
      return loadingIndicatorProp===true ? <LoadingIcon size={size} spinning={spinning}/> :
             (loadingIndicatorProp===false) ? undefined : loadingIndicatorProp as React.ReactElement<HTMLElement>;
   },[loadingIndicatorProp, size, spinning]);

   return (
      <AntdSpin
         size={props.size}
         delay={props.delay}
         spinning={props.spinning}
         tip={props.text}
         className={`uf-activity-indicator ${props.size===undefined ? 'uf-activity-indicator-no-size' : ''} ${props.className || ''}`}
         wrapperClassName={`uf-activity-indicator-wrapper ${props.wrapperClassName || ''}`}
         indicator={loadingIndicator}
      >
         {props.children}
      </AntdSpin>
   );
};
